function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a3a9ad;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M98,86.14a3.43,3.43,0,0,0-3.41,3.67A3.37,3.37,0,0,0,98,93.34a3.31,3.31,0,0,0,3.36-3.53A3.4,3.4,0,0,0,98,86.14Z",
  transform: "translate(-61.95 -61.95)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M89.45,62A27.5,27.5,0,1,0,117,89.45,27.5,27.5,0,0,0,89.45,62Zm-1,26.64c0,4.41-2.57,7.2-6.82,7.2-4,0-6.77-2.62-6.77-7.2v-10H77.7v9.81c0,2.71,1.44,4.68,3.89,4.68,2.28,0,3.92-1.75,3.92-4.68V78.56h2.9Zm10,7.2a4.52,4.52,0,0,1-3.67-1.63l0,0v6.17H92V83.88h2.69v1.4h0a4.71,4.71,0,0,1,3.7-1.56c3.24,0,5.66,2.54,5.66,6.07S101.66,95.79,98.39,95.79Z",
  transform: "translate(-61.95 -61.95)"
});

function SvgUpButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpButton);
export default __webpack_public_path__ + "static/media/Up_Button.895a2784.svg";
export { ForwardRef as ReactComponent };